<template>
<b-container fluid class="container">
  <!-- Botones Cortas --> 
  <div class="row justify-content-center">
    <div v-if="this.botonesC == true" class="col-sm-12 text-center">
      <b-row class="justify-content-md-center">
        <b-col ><b-button @click.prevent="reservaHora()" class="button_s">Hora</b-button></b-col>
        <b-col><b-button @click.prevent="reservaDia()" class="button_s">Día</b-button></b-col>
        <b-col><b-button @click.prevent="reservaSemana()" class="button_s">Semana</b-button></b-col>
        <b-col><b-button @click.prevent="reservaMes()" class="button_s">Mes</b-button></b-col>
        </b-row>
    </div>

  <!-- Suscripciones Horas --> 
    <div v-if="this.hora == true" class="col-sm-12 text-center mb-4">
      <b-row class="justify-content-md-center">
      <div class="col-sm-4 text-center">
          <b-col>
            <h6>Selecciona el día</h6>
            <!-- <b-form-input v-model="FechaHora" class="inputTime" id="date" type="date"></b-form-input> -->
            <b-form-datepicker id="date1" class="inputTime" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="es-mx" v-model="FechaHora" placeholder="Calendario"></b-form-datepicker>
          <!-- <div class="mt-2">Value: "{{ FechaHora }}"</div> -->
          </b-col>
      </div>
        <b-col sm="3">
          <b-form-group id="input-group-11" class="text-left" label-for="input-11">
          <h6>Hora Inicio</h6>
              <b-form-select id="input-11" v-model="HoraInicio" :options="horasI" class="inputTime"></b-form-select>
          </b-form-group>
          <!-- <div class="mt-2">Value: "{{ HoraInicio }}"</div> -->
        </b-col>
        <b-col sm="3">
          <b-form-group id="input-group-11" class="text-left" label-for="input-11">
          <h6>Hora Fin</h6>
              <b-form-select id="input-11" v-model="HoraFin" :options="horasF" class="inputTime"></b-form-select>
          </b-form-group>
          <!-- <div class="mt-2">Value: "{{ HoraFin }}"</div> -->
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center">  
        <p>Todas las reservas deben ser con 24 hrs de ancitipación en un horario de 9 hrs a 18 hrs.</p>

        <b-col v-if="this.fechaH == true" sm="4">
          <b-alert show class="text-center" variant="danger"><b-icon class="mr-1" icon="calendar2-x"></b-icon>Fecha Incorrecta</b-alert>
            <p>La fecha debe ser mayor a hoy.</p>
        </b-col>

        <b-col v-if="this.horasH == true" sm="4">
          <b-alert show class="text-center" variant="danger"><b-icon class="mr-1" icon="clock-history"></b-icon>Hora Incorrecta</b-alert>
            <p>La hora fin debe ser mayor.</p>
        </b-col>

        <b-col v-if="this.datosH == true" sm="4">
          <b-alert show class="text-center" variant="danger"><b-icon class="mr-1" icon="file-excel"></b-icon>Datos Incorrectos</b-alert>
            <p>Revisar la fecha, hora inicio y hora fin.</p>
        </b-col>

      </b-row>
      <b-row v-if="this.validaH() == true" class="justify-content-md-center">
      <!-- <b-row class="justify-content-md-center"> -->
        <b-col sm="4">
           <b-row class="text-left">
            <b-col><h6>Fecha:</h6></b-col>
            <b-col>{{ FechaHora }}</b-col>
          </b-row>
          <b-row class="text-left">
            <b-col><h6>Número Hrs:</h6></b-col>
            <b-col> {{(this.HoraFin - this.HoraInicio).toFixed(2).substring(0,1)}} hrs {{(this.HoraFin - this.HoraInicio).toFixed(2).substring(2,4)}} min</b-col>
          </b-row>
          <b-row class="text-left">
            <b-col><h6>Costo Hr:</h6></b-col>
            <b-col>${{this.hrs}}</b-col>
          </b-row>
          <b-row class="text-left">
            <b-col><h6>Costo Total:</h6></b-col>
            <b-col>${{calculaHrs()}}</b-col>
          </b-row>
        </b-col>
        <b-col  sm="9">
            <button @click.prevent="cotizaHrs()" class="button_H mt-2">SOLICITAR COTIZACIÓN</button>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center">
        <b-col>
          <b-button @click.prevent="volverH()" variant="light">Regresar</b-button>
        </b-col>
      </b-row>
    </div>

 <!-- Suscripciones Dias --> 
    <div  v-if="this.dia == true" class="col-sm-12 text-center mb-4">
      <b-row class="justify-content-md-center">
        <b-col sm="4">
          <h6>Día Inicio</h6>
            <b-form-datepicker id="date2" class="inputTime" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="es-mx" v-model="DiaInicio" placeholder="Desde"></b-form-datepicker>
          <!-- <b-form-input v-model="DiaInicio" class="inputTimeS" id="date" type="date"></b-form-input> -->
              <!-- <p>{{ DiaInicio }}</p> -->
        </b-col>
        <b-col sm="4">
          <h6>Dia Fin</h6>
            <b-form-datepicker id="date3" class="inputTime" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="es-mx" v-model="DiaFin" placeholder="Hasta"></b-form-datepicker>
          <!-- <b-form-input v-model="DiaFin" class="inputTimeS" id="date" type="date"></b-form-input> -->
              <!-- <p>{{ DiaFin }}</p> -->
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center">  
        <p>Todas las reservas deben ser con 24 hrs de ancitipación en un horario de 9 hrs a 18 hrs.</p>

        <b-col v-if="this.fechaD == true" sm="4">
          <b-alert show class="text-center" variant="danger"><b-icon class="mr-1" icon="calendar2-x"></b-icon>Fecha Incorrecta</b-alert>
            <p>La fecha fin debe ser mayor a la fecha inicio.</p>
        </b-col>

        <b-col v-if="this.fechaI == true" sm="4">
          <b-alert show class="text-center" variant="danger"><b-icon class="mr-1" icon="calendar2-x"></b-icon>Fecha Incorrecta</b-alert>
            <p>La fecha inicio debe ser mayor al día de Hoy.</p>
        </b-col>

        <b-col v-if="this.dias7 == true" sm="4">
          <b-alert show class="text-center" variant="danger"><b-icon class="mr-1" icon="calendar2-x"></b-icon>Días Excedentes</b-alert>
            <p>El número de días debe ser menor a 7.</p>
            <p>Se sugiere suscripción Semanal.</p>
        </b-col>

      </b-row>
       <b-row v-if="this.diasN() == true" class="justify-content-md-center">
        <b-col sm="4">
          <b-row class="text-left">
            <b-col><h6>Número Días:</h6></b-col>
            <b-col> {{this.diaN}}</b-col>
          </b-row>
          <b-row class="text-left">
            <b-col><h6>Costo Día:</h6></b-col>
            <b-col>${{this.days}}</b-col>
          </b-row>
          <b-row class="text-left">
            <b-col><h6>Costo Total:</h6></b-col>
            <b-col>${{calcularDias()}}</b-col>
          </b-row>
        </b-col>
        <b-col  sm="9">
            <button @click.prevent="cotizaDias()" class="button_H mt-2">SOLICITAR COTIZACIÓN</button>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center">
        <b-col>
          <b-button @click.prevent="volverD()" variant="light">Regresar</b-button>
        </b-col>
      </b-row>
    </div>

 <!-- Suscripciones Semanas --> 
    <div  v-if="this.semana == true" class="col-sm-12 text-center mb-4">
      <b-row class="justify-content-md-center">
        <b-col sm="4">
          <h6>Desde</h6>
          <!-- <b-form-input v-model="SemInicio" class="inputTimeS" id="date" type="date"></b-form-input> -->
          <b-form-datepicker id="date4" class="inputTime" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="es-mx" v-model="SemInicio" placeholder="Desde"></b-form-datepicker>
        </b-col>
        <b-col sm="4">
          <h6>Hasta</h6>
          <!-- <b-form-input v-model="SemFin" class="inputTimeS" id="date" type="date"></b-form-input> -->
          <b-form-datepicker id="date5" class="inputTime" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="es-mx" v-model="SemFin" placeholder="Hasta"></b-form-datepicker>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center">  
        <p>Todas las reservas deben ser con 24 hrs de ancitipación en un horario de 9 hrs a 18 hrs.</p>

        <b-col v-if="this.fechaS == true" sm="4">
          <b-alert show class="text-center" variant="danger"><b-icon class="mr-1" icon="calendar2-x"></b-icon>Fecha Incorrecta</b-alert>
            <p>La fecha fin debe ser mayor a la fecha inicio.</p>
        </b-col>
        <b-col v-if="this.semanaIg == true" sm="4">
          <b-alert show class="text-center" variant="danger"><b-icon class="mr-1" icon="calendar2-x"></b-icon>Fecha Incorrecta</b-alert>
            <p>La fecha Inicio debe ser mayor al día de hoy.</p>
        </b-col>

        <b-col v-if="this.semanaCorta == true" sm="4">
          <b-alert show class="text-center" variant="danger"><b-icon class="mr-1" icon="calendar2-x"></b-icon>Error de Fecha</b-alert>
            <p>Debes seleccionar al menos 7 días.</p>
        </b-col>

        <b-col v-if="this.semanaLarga == true" sm="4">
          <b-alert show class="text-center" variant="danger"><b-icon class="mr-1" icon="calendar2-x"></b-icon>Semanas Excecentes</b-alert>
            <p>El número de semanas permitido son 3.</p>
            <p>Se seguiere una Suscripción Mensual.</p>
        </b-col>
        
      </b-row>
       <b-row v-if="this.semanas() == true" class="justify-content-md-center">
        <b-col sm="4">
          <b-row class="text-left">
            <b-col><h6>Número Semanas:</h6></b-col>
            <b-col> {{this.semanaN}} </b-col>
          </b-row>
          <b-row class="text-left">
            <b-col><h6>Costo Semanas:</h6></b-col>
            <b-col>${{this.weeks}}</b-col>
          </b-row>
          <b-row v-if="this.diasExtras == true" class="text-left">
            <b-col><h6>Días Extras:</h6></b-col>
            <b-col>{{this.diferenciaDias}}</b-col>
          </b-row>
          <b-row v-if="this.diasExtras == true" class="text-left">
            <b-col><h6>Costo Día:</h6></b-col>
            <b-col>${{this.days}}</b-col>
          </b-row>
          <b-row class="text-left">
            <b-col><h6>Costo Total:</h6></b-col>
            <b-col>${{calcularSemanas()}}</b-col>
          </b-row>
        </b-col>
        <b-col  sm="9">
            <button @click.prevent="cotizaSemanas()" class="button_H mt-2">SOLICITAR COTIZACIÓN</button>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center">
        <b-col>
          <b-button @click.prevent="volverS()" variant="light">Regresar</b-button>
        </b-col>
      </b-row>
    </div>

 <!-- Suscripciones Meses --> 
    <div v-if="this.mes == true" class="col-sm-12 text-center mb-4">
      <b-row class="justify-content-md-center">
        <b-col sm="4">
          <h6>Desde</h6>
          <!-- <b-form-input v-model="MesInicio" class="inputTimeS" id="date" type="date"></b-form-input> -->
          <b-form-datepicker id="date6" class="inputTime" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="es-mx" v-model="MesInicio" placeholder="Desde"></b-form-datepicker>
        </b-col>
        <b-col sm="4">
          <h6>Hasta</h6>
          <!-- <b-form-input v-model="MesFin" class="inputTimeS" id="date" type="date"></b-form-input> -->
          <b-form-datepicker id="date7" class="inputTime" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="es-mx" v-model="MesFin" placeholder="Hasta"></b-form-datepicker>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center">  
        <p>Todas las reservas deben ser con 24 hrs de ancitipación en un horario de 9 hrs a 18 hrs.</p>

        <b-col v-if="this.fechaM == true" sm="4">
          <b-alert show class="text-center" variant="danger"><b-icon class="mr-1" icon="calendar2-x"></b-icon>Fecha Incorrecta</b-alert>
            <p>La fecha fin debe ser mayor a la fecha inicio.</p>
        </b-col>

        <b-col v-if="this.mesIgu == true" sm="4">
          <b-alert show class="text-center" variant="danger"><b-icon class="mr-1" icon="calendar2-x"></b-icon>Fecha Incorrecta</b-alert>
            <p>La fecha Inicio debe ser mayor al día de hoy.</p>
        </b-col>

        <b-col v-if="this.mesMenor == true" sm="4">
          <b-alert show class="text-center" variant="danger"><b-icon class="mr-1" icon="calendar2-x"></b-icon>Error de Fecha</b-alert>
            <p>Debes seleccionar al menos 30 días.</p>
        </b-col>

        <b-col v-if="this.mesMayor == true" sm="4">
          <b-alert show class="text-center" variant="danger"><b-icon class="mr-1" icon="calendar2-x"></b-icon>Meses Excecentes</b-alert>
            <p>El número de meses permitido son 11.</p>
            <p>Se seguiere una Suscripción Larga.</p>
        </b-col>

      </b-row>
       <b-row v-if="this.meses() == true" class="justify-content-md-center">
        <b-col sm="4">
          <b-row v-if="this.diasExtrasMes == true" class="text-left">
            <b-col><h6>Días Extras:</h6></b-col>
            <b-col>{{this.diferenciaDiasMes}}</b-col>
          </b-row>
          <b-row v-if="this.diasExtrasMes == true" class="text-left">
            <b-col><h6>Costo Día:</h6></b-col>
            <b-col>${{this.days}}</b-col>
          </b-row>
          <b-row v-if="this.semanasExtrasMes == true" class="text-left">
            <b-col><h6>Semanas Extras:</h6></b-col>
            <b-col>{{this.semanasMes}}</b-col>
          </b-row>
          <b-row v-if="this.semanasExtrasMes == true" class="text-left">
            <b-col><h6>Costo Semana:</h6></b-col>
            <b-col>${{this.weeks}}</b-col>
          </b-row>
          <b-row class="text-left">
            <b-col><h6>Número Meses:</h6></b-col>
            <b-col> {{this.mesN}} </b-col>
          </b-row>
          <b-row class="text-left">
            <b-col><h6>Costo Mes:</h6></b-col>
            <b-col>${{this.months}}</b-col>
          </b-row>
          <b-row class="text-left">
            <b-col><h6>Costo Total:</h6></b-col>
            <b-col>${{calcularMeses()}}</b-col>
          </b-row>
        </b-col>
        <b-col  sm="9">
            <button @click.prevent="cotizaMeses()" class="button_H mt-2">SOLICITAR COTIZACIÓN</button>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center">
        <b-col>
          <b-button @click.prevent="volverM()" variant="light">Regresar</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</b-container>
</template>

<script>

export default {
  name: 'SuscripcionCortas',
    data() {
    return {
      botonesC: false,
      botonesL: false,
      botonesLU: false,

      //cortas
      hora: false,
      dia: false,
      semana: false,
      mes: false,

      // excepciones hrs
      fechaH: false,
      horasH: false,
      datosH: false,

    // días
    dias7: false,
    fechaI: false, 
    fechaD: false,
    diasp: false,

    //Semanas
    diasExtras: false,
    semanaLarga: false,
    semanaCorta: false,
    semanaIg: false,
    fechaS: false,
    semanap: false,

    //Meses
    diasExtrasMes: false,
    semanasExtrasMes: false,
    semanasMes: 0,
    mesMenor: false,
    mesMayor: false,
    mesIgu: false,
    fechaM: false,
    mesp: false,

      contents: null,
      autos: [],
      photos: [],
      vin: this.$route.query.vin,
      type: this.$route.query.type,
      timeout: null,
      HoraInicio: 0,
      HoraFin: 1,
      FechaHora: '',
      DiaInicio: '',
      DiaFin: '',
      SemInicio: '',
      SemFin: '',
      MesInicio: '',
      MesFin: '',
      horasN: false,
      diaN: '',
      semanaN: '',
      mesN: '',

      horasI: [
        { value: 0, text: '9:00 hrs' },
        { value: 0.15, text: '9:15 hrs' },
        { value: 0.30, text: '9:30 hrs' },
        { value: 0.45, text: '9:45 hrs' },
        { value: 1, text: '10:00 hrs' },
        { value: 1.15, text: '10:15 hrs' },
        { value: 1.30, text: '10:30 hrs' },
        { value: 1.45, text: '10:45 hrs' },
        { value: 2, text: '11:00 hrs' },
        { value: 2.15, text: '11:15 hrs' },
        { value: 2.30, text: '11:30 hrs' },
        { value: 2.45, text: '11:45 hrs' },
        { value: 3, text: '12:00 hrs' },
        { value: 3.15, text: '12:15 hrs' },
        { value: 3.30, text: '12:30 hrs' },
        { value: 3.45, text: '12:45 hrs' },
        { value: 4, text: '13:00 hrs' },
        { value: 4.15, text: '13:15 hrs' },
        { value: 4.30, text: '13:30 hrs' },
        { value: 4.45, text: '13:45 hrs' },
        { value: 5, text: '14:00 hrs' },
        { value: 5.15, text: '14:15 hrs' },
        { value: 5.30, text: '14:30 hrs' },
        { value: 5.45, text: '14:45 hrs' },
        { value: 6, text: '15:00 hrs' },
        { value: 6.15, text: '15:15 hrs' },
        { value: 6.30, text: '15:30 hrs' },
        { value: 6.45, text: '15:45 hrs' },
        { value: 7, text: '16:00 hrs' },
        { value: 7.15, text: '16:15 hrs' },
        { value: 7.30, text: '16:30 hrs' },
        { value: 7.45, text: '16:45 hrs' },
        { value: 8, text: '17:00 hrs' },
        { value: 8.15, text: '17:15 hrs' },
        { value: 8.30, text: '17:30 hrs' },
        { value: 8.45, text: '17:45 hrs' },
        { value: 9, text: '18:00 hrs' }
      ],
      horasF: [
        { value: 1, text: '10:00 hrs' },
        { value: 1.15, text: '10:15 hrs' },
        { value: 1.30, text: '10:30 hrs' },
        { value: 1.45, text: '10:45 hrs' },
        { value: 2, text: '11:00 hrs' },
        { value: 2.15, text: '11:15 hrs' },
        { value: 2.30, text: '11:30 hrs' },
        { value: 2.45, text: '11:45 hrs' },
        { value: 3, text: '12:00 hrs' },
        { value: 3.15, text: '12:15 hrs' },
        { value: 3.30, text: '12:30 hrs' },
        { value: 3.45, text: '12:45 hrs' },
        { value: 4, text: '13:00 hrs' },
        { value: 4.15, text: '13:15 hrs' },
        { value: 4.30, text: '13:30 hrs' },
        { value: 4.45, text: '13:45 hrs' },
        { value: 5, text: '14:00 hrs' },
        { value: 5.15, text: '14:15 hrs' },
        { value: 5.30, text: '14:30 hrs' },
        { value: 5.45, text: '14:45 hrs' },
        { value: 6, text: '15:00 hrs' },
        { value: 6.15, text: '15:15 hrs' },
        { value: 6.30, text: '15:30 hrs' },
        { value: 6.45, text: '15:45 hrs' },
        { value: 7, text: '16:00 hrs' },
        { value: 7.15, text: '16:15 hrs' },
        { value: 7.30, text: '16:30 hrs' },
        { value: 7.45, text: '16:45 hrs' },
        { value: 8, text: '17:00 hrs' },
        { value: 8.15, text: '17:15 hrs' },
        { value: 8.30, text: '17:30 hrs' },
        { value: 8.45, text: '17:45 hrs' },
        { value: 9, text: '18:00 hrs' }
      ]
      };
  },

  methods: {

    clearTimeout() {
        if (this.timeout) {
          clearTimeout(this.timeout)
          this.timeout = null
        }
    },

    setTimeout(callback) {
        this.clearTimeout()
        this.timeout = setTimeout(() => {
          this.clearTimeout()
          callback()
        }, 5000);
    },
    cargarInfoVehiculo(){
          // console.log('Seminuevo');
              axios.get("https://pruebas.autocomcube.mx/ab/api/usedstock", { //QA
              //axios.get("https://autocomcube.mx/ab/api/usedstock", { //PRO        
              headers: {
                Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                'Content-Type': 'application/json',
              },
              params: {vin: this.vin,},
            }).then((response) => {
                    this.autos = response.data.usedstock;
                    this.photos = response.data.usedstock[0].spincarphotos.photos;
                    sessionStorage.setItem("TipoSuscripcion", 1);
                    this.botonesC = true;
                    this.hrs = response.data.usedstock[0].suscriptionDetails.hour;
                    this.days = response.data.usedstock[0].suscriptionDetails.day;
                    this.weeks = response.data.usedstock[0].suscriptionDetails.week;
                    this.months = response.data.usedstock[0].suscriptionDetails.month;
            }).catch(error => {
          console.log(error);
        });
    },

    siguiente(){
      this.$router.push({ path: '/formulario'});
    },

    reservaHora(){
      this.botonesC = false;
      this.hora = true;
    },

    volverH(){
      this.datosH = false;
      this.fechaH = false;
      this.horasH = false;
      this.horasN = false;
      this.botonesC = true;
      this.hora = false;
      this.HoraInicio = 0,
      this.HoraFin = 1,
      this.FechaHora = ''
    },

    reservaDia(){
      this.botonesC = false;
      this.dia = true;
    },

    volverD(){
      this.dias7 = false;
      this.fechaI = false;
      this.fechaD = false;
      this.diasp = false;
      this.botonesC = true;
      this.dia = false;
      this.DiaInicio = '';
      this.DiaFin = '';
    },

    reservaSemana(){
      this.botonesC = false;
      this.semana = true;
    },
  
    volverS(){
      this.semanaLarga = false;
      this.semanaCorta = false;
      this.semanaIg = false;
      this.fechaS = false;
      this.semanap = false;
      this.botonesC = true;
      this.semana = false;
      this.SemInicio = '';
      this.SemFin = '';
      this.semanaN = '';
    },

    reservaMes(){
      this.botonesC = false;
      this.mes = true;
    },

    volverM(){
      this.semanasMes = 0;
      this.semanasExtrasMes = false;
      this.diasExtrasMes = false;
      this.mesMenor = false;
      this.mesMayor = false;
      this.mesIgu = false;
      this.mesp = false;
      this.fechaM = false; 
      this.botonesC = true;
      this.mes = false;
      this.MesInicio ='';
      this.MesFin = '';
    },

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatPriceCostos(value) {
        let val = (value/1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    validaH(){
       const date = new Date();
       const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
       const diac = new Date(output).getTime();
       const diasuno = Math.round(diac/(1000*60*60*24));
       const otroD = new Date(this.FechaHora).getTime();
       const diasdos = Math.round(otroD/(1000*60*60*24));


      if (diasdos <= diasuno && this.HoraFin > this.HoraInicio){
        this.datosH = false;
        this.fechaH = true;
        this.horasH = false;
        this.horasN = false;
      } else if (diasdos <= diasuno && this.HoraFin < this.HoraInicio){
        this.datosH = true;
        this.fechaH = false;
        this.horasH = false;
        this.horasN = false;
      } else if (diasdos > diasuno && this.HoraFin < this.HoraInicio){
        this.datosH = false;
        this.fechaH = false;
        this.horasH = true;
        this.horasN = false;
      } else if (this.FechaHora == '' && this.HoraFin < this.HoraInicio){
        this.datosH = false;
        this.fechaH = true;
        this.horasH = false;
        this.horasN = false;
      }  else if (diasdos > diasuno && this.HoraFin == this.HoraInicio){
        this.datosH = false;
        this.fechaH = false;
        this.horasH = true;
        this.horasN = false;
      }  else if (diasdos <= diasuno && this.HoraFin == this.HoraInicio){
        this.datosH = true;
        this.fechaH = false;
        this.horasH = false;
        this.horasN = false;
      }  else if (diasdos > diasuno && this.HoraFin > this.HoraInicio){
        this.datosH = false;
        this.fechaH = false;
        this.horasH = false;
        this.horasN = true;
      }

      return this.horasN;
    },

    calculaHrs(){
      this.hrsTotales = ((this.HoraFin - this.HoraInicio)*this.hrs).toFixed(2);
      console.log('Horas Totales --->',this.hrsTotales);
      return this.hrsTotales;
    },

    cotizaHrs(){
      sessionStorage.setItem("fechaVigencia", this.FechaHora);
      sessionStorage.setItem("modalidadNegocio", 1);
      sessionStorage.setItem("valorTotal", this.hrsTotales);
      sessionStorage.setItem("valorSuscripcion", (((this.HoraFin - this.HoraInicio)*this.hrs)+2400).toFixed(2));
      sessionStorage.setItem("TipoSuscripcion", 1);
      this.$router.push({ path: '/formularioCortas'});
    },

    cotizaDias(){
      sessionStorage.setItem("fechaVigencia", this.DiaFin);
      sessionStorage.setItem("modalidadNegocio", 2);
      sessionStorage.setItem("valorTotal", this.diasTotales);
      sessionStorage.setItem("valorSuscripcion", ((this.diaN*this.days)+2400).toFixed(2));
      sessionStorage.setItem("TipoSuscripcion", 1);
      this.$router.push({ path: '/formularioCortas'});
    },

    cotizaSemanas(){
      sessionStorage.setItem("fechaVigencia", this.SemFin);
      sessionStorage.setItem("modalidadNegocio", 3);
      sessionStorage.setItem("valorTotal", this.semanasTotales);
      sessionStorage.setItem("valorSuscripcion", (((this.semanaN * this.weeks)+(this.diferenciaDias*this.days))+2400).toFixed(2));
      sessionStorage.setItem("TipoSuscripcion", 1);
      this.$router.push({ path: '/formularioCortas'});
    },

    cotizaMeses(){
      sessionStorage.setItem("fechaVigencia", this.MesFin);
      sessionStorage.setItem("modalidadNegocio", 4);
      sessionStorage.setItem("valorTotal", this.mesesTotales);
      sessionStorage.setItem("valorSuscripcion", (((this.mesN * this.months) + (this.semanasMes * this.weeks) + (this.diferenciaDiasMes * this.days))+2400).toFixed(2));
      sessionStorage.setItem("TipoSuscripcion", 1);
      this.$router.push({ path: '/formularioCortas'});
    },
    diasN(){
          const date = new Date();
          const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
          const dia = new Date(output).getTime();
          const diac = Math.round(dia/(1000*60*60*24));
          const prueba = new Date(this.DiaInicio).getTime();
          const contdias1 = Math.round(prueba/(1000*60*60*24));
          const prueba2 = new Date(this.DiaFin).getTime();
          const contdias2 = Math.round(prueba2/(1000*60*60*24));

          console.log('Fecha Hoy-->',output);
          console.log('Fecha Inicio-->',contdias1);
          console.log('Fecha Fin-->',contdias2);
        
        if( contdias1 == diac){
          console.log('Uno');
            this.diaN = 0;
            this.fechaI = true;
            this.diasp = false;
            this.dias7 = false;
        } else  if(contdias2 <= contdias1){
            console.log('tres');
            this.diaN = 0;
            this.fechaI = false;
            this.fechaD = true;
            this.diasp = false;
            this.dias7 = false;
        } else {
          const resta = contdias2 - contdias1;
          if( resta >= 7){
            console.log('Mayor');
              this.diaN = 0;
              this.dias7 = true;
              this.fechaI = false;
              this.fechaD = false;
              this.diasp = false;
          } else if( (resta).toString() == 'NaN'){
            console.log('cuatro');
              this.diaN = 0;
              this.dias7 = false;
              this.fechaI = false;
              this.fechaD = false;
              this.diasp = false;
          } else {
            console.log('cinco');
              this.dias7 = false;
              this.fechaI = false;
              this.diaN = resta;
              this.fechaD = false;
              this.diasp = true; 
          }
        }

      return this.diasp;
    },

    calcularDias(){
      this.diasTotales = (this.diaN*this.days).toFixed(2);
      console.log('Días Totales-->',this.diasTotales);
      return this.diasTotales
    },
    semanas(){

          const date = new Date();
          const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
          const dia = new Date(output).getTime();
          const diac = Math.round(dia/(1000*60*60*24));

          const semanaI = new Date(this.SemInicio).getTime();
          const diasI = Math.round(semanaI/(1000*60*60*24));
          const semanaF = new Date(this.SemFin).getTime();
          const diasF = Math.round(semanaF/(1000*60*60*24));
          const resta = diasF - diasI;

         if( diasI == diac){
            this.semanaLarga = false;
            this.semanaCorta = false;
            this.semanaIg = true;
            this.fechaS = false;
            this.semanap = false;
            this.semanaN = 0;
        } else
        
        if( diasI > diac && (diasF).toString() == 'NaN'){
            this.semanaLarga = false;
            this.semanaCorta = false;
            this.semanaIg = false;
            this.fechaS = false;
            this.semanap = false;
            this.semanaN = 0;
        } else
        
        if (diasF <= diasI){
            this.semanaIg = false;
            this.semanaLarga = false;
            this.semanaCorta = false;
            this.semanaIg = false;
            this.fechaS = true;
            this.semanap = false;
            this.semanaN = 1;
        } else

         if( resta >= 7 && resta <= 13){
           this.diferenciaDias = (resta - 7);
           if( this.diferenciaDias > 0 && this.diferenciaDias < 7){
              this.diasExtras = true;
              this.semanaLarga = false;
              this.semanaCorta = false;
              this.semanaIg = false;
              this.fechaS = false;
              this.semanap = true;
              this.semanaN = 1;
           } else {
            this.diasExtras = false;
            this.semanaLarga = false;
            this.semanaCorta = false;
            this.semanaIg = false;
            this.fechaS = false;
            this.semanap = true;
            this.semanaN = 1;
           }
        } else
        
        if( resta >= 14 && resta <= 20){
           this.diferenciaDias = (resta - 14);
           if( this.diferenciaDias > 0 && this.diferenciaDias < 7){
              this.diasExtras = true;
              this.semanaLarga = false;
              this.semanaCorta = false;
              this.semanaIg = false;
              this.fechaS = false;
              this.semanap = true;
              this.semanaN = 2;
           } else {
            this.diasExtras = false;
            this.semanaLarga = false;
            this.semanaCorta = false;
            this.semanaIg = false;
            this.fechaS = false;
            this.semanap = true;
            this.semanaN = 2;
          }
        } else
        
        if( resta >= 21 && resta <= 27){
           this.diferenciaDias = (resta - 21);
           if( this.diferenciaDias > 0 && this.diferenciaDias < 7){
              this.diasExtras = true;
              this.semanaLarga = false;
              this.semanaCorta = false;
              this.semanaIg = false;
              this.fechaS = false;
              this.semanap = true;
              this.semanaN = 3;
           } else {
            this.diasExtras = false;
            this.semanaLarga = false;
            this.semanaCorta = false;
            this.semanaIg = false;
            this.fechaS = false;
            this.semanap = true;
            this.semanaN = 3;
          }
        } else
        
        if( resta >= 28 ){
            this.semanaLarga = true;
            this.semanaCorta = false;
            this.semanaIg = false;
            this.fechaS = false;
            this.semanap = false;
            this.semanaN = 0;
         } else
        
        if( resta < 7 ){
            this.semanaLarga = false;
            this.semanaCorta = true;
            this.semanaIg = false;
            this.fechaS = false;
            this.semanap = false;
            this.semanaN = 0;
          }

        return this.semanap;
      },

    calcularSemanas(){
      this.semanasTotales = ((this.semanaN * this.weeks)+(this.diferenciaDias*this.days)).toFixed(2);
      console.log('Semanas Totales --->',this.semanasTotales);
      return this.semanasTotales;
    },
    meses(){

      const date = new Date();
      const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      const dia = new Date(output).getTime();
      const diac = Math.round(dia/(1000*60*60*24));

      const mesI = new Date(this.MesInicio).getTime();
      const mes1 = Math.round(mesI/(1000*60*60*24));
      const mesF = new Date(this.MesFin).getTime();
      const mes2 = Math.round(mesF/(1000*60*60*24));
      const resta = mes2 - mes1;

      if( mes1 == diac){
            this.mesMenor = false;
            this.mesMayor = false;
            this.mesIgu = true;
            this.fechaM = false;
            this.mesp = false;
            this.mesN = 0;
        } else

        if( mes1 > diac && (mes2).toString() == 'NaN'){
            this.mesMenor = false;
            this.mesMayor = false;
            this.mesIgu = false;
            this.fechaM = false;
            this.mesp = false;
            this.mesN = 0;
        } else

        if (mesF <= mesI){
            this.mesMenor = false;
            this.mesMayor = false;
            this.mesIgu = false;
            this.fechaM = true;
            this.mesp = false;
            this.mesN = 0;
        }  else

        if( resta >= 30 && resta <= 59){
      	   console.log('días -->',resta);
           this.diferenciaDiasM = (resta - 30);
           if( this.diferenciaDiasM > 0 && this.diferenciaDiasM < 7){
             this.diferenciaDiasMes = this.diferenciaDiasM;
             console.log('Días extras-->',this.diferenciaDiasMes);
              this.semanasMes = 0;
              this.diasExtrasMes = true;
              this.semanasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 1;
           } else if( this.diferenciaDiasM > 7 && this.diferenciaDiasM <= 13){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 7);
              console.log('Diferencia dias mes 1 semana 1-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 1;
           }  else if( this.diferenciaDiasM > 14 && this.diferenciaDiasM <= 20){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 14);
              console.log('Diferencia dias mes 1 semana 2-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 1;
           } else if( this.diferenciaDiasM > 21 && this.diferenciaDiasM <= 27){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 21);
              console.log('Diferencia dias mes 1 semana 3-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 1;
           }  else if( this.diferenciaDiasM > 28 && this.diferenciaDiasM <= 29){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 28);
              console.log('Diferencia dias mes 1 semana 4-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 1;
           } else if( this.diferenciaDiasM == 0){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = false;
              this.semanasMes = 0;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 1;
           } else if( this.diferenciaDiasM == 7){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 1;
           } else if( this.diferenciaDiasM == 14 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 1;
           } else if( this.diferenciaDiasM == 21 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 1;
           } else if( this.diferenciaDiasM == 28 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 1;
           } else {
              this.semanasMes = 0;
              this.semanasExtrasMes = false;
              this.diasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 1;
           }
         } else
         
         if( resta >= 60 && resta <= 89){
      	   console.log('días -->',resta);
           this.diferenciaDiasM = (resta - 60);
           if( this.diferenciaDiasM > 0 && this.diferenciaDiasM < 7){
             this.diferenciaDiasMes = this.diferenciaDiasM;
             console.log('Días extras-->',this.diferenciaDiasMes);
              this.semanasMes = 0;
              this.diasExtrasMes = true;
              this.semanasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 2;
           } else if( this.diferenciaDiasM > 7 && this.diferenciaDiasM <= 13){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 7);
              console.log('Diferencia dias mes 1 semana 1-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 2;
           }  else if( this.diferenciaDiasM > 14 && this.diferenciaDiasM <= 20){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 14);
              console.log('Diferencia dias mes 1 semana 2-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 2;
           } else if( this.diferenciaDiasM > 21 && this.diferenciaDiasM <= 27){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 21);
              console.log('Diferencia dias mes 1 semana 3-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 2;
           }  else if( this.diferenciaDiasM > 28 && this.diferenciaDiasM <= 29){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 28);
              console.log('Diferencia dias mes 1 semana 4-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 2;
           } else if( this.diferenciaDiasM == 0){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = false;
              this.semanasMes = 0;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 2;
           } else if( this.diferenciaDiasM == 7){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 2;
           } else if( this.diferenciaDiasM == 14 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 2;
           } else if( this.diferenciaDiasM == 21 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 2;
           } else if( this.diferenciaDiasM == 28 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 2;
           } else {
              this.semanasMes = 0;
              this.semanasExtrasMes = false;
              this.diasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 2;
           }
         } else
         
         if( resta >= 90 && resta <= 119){
      	   console.log('días -->',resta);
           this.diferenciaDiasM = (resta - 90);
           if( this.diferenciaDiasM > 0 && this.diferenciaDiasM < 7){
             this.diferenciaDiasMes = this.diferenciaDiasM;
             console.log('Días extras-->',this.diferenciaDiasMes);
              this.semanasMes = 0;
              this.diasExtrasMes = true;
              this.semanasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 3;
           } else if( this.diferenciaDiasM > 7 && this.diferenciaDiasM <= 13){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 7);
              console.log('Diferencia dias mes 1 semana 1-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 3;
           }  else if( this.diferenciaDiasM > 14 && this.diferenciaDiasM <= 20){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 14);
              console.log('Diferencia dias mes 1 semana 2-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 3;
           } else if( this.diferenciaDiasM > 21 && this.diferenciaDiasM <= 27){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 21);
              console.log('Diferencia dias mes 1 semana 3-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 3;
           }  else if( this.diferenciaDiasM > 28 && this.diferenciaDiasM <= 29){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 28);
              console.log('Diferencia dias mes 1 semana 4-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 3;
           } else if( this.diferenciaDiasM == 0){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = false;
              this.semanasMes = 0;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 3;
           } else if( this.diferenciaDiasM == 7){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 3;
           } else if( this.diferenciaDiasM == 14 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 3;
           } else if( this.diferenciaDiasM == 21 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 3;
           } else if( this.diferenciaDiasM == 28 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 3;
           } else {
              this.semanasMes = 0;
              this.semanasExtrasMes = false;
              this.diasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 3;
           }
         } else
         
         if( resta >= 120 && resta <= 149){
      	   console.log('días -->',resta);
           this.diferenciaDiasM = (resta - 120);
           if( this.diferenciaDiasM > 0 && this.diferenciaDiasM < 7){
             this.diferenciaDiasMes = this.diferenciaDiasM;
             console.log('Días extras-->',this.diferenciaDiasMes);
             this.semanasMes = 0;
              this.diasExtrasMes = true;
              this.semanasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 4;
           } else if( this.diferenciaDiasM > 7 && this.diferenciaDiasM <= 13){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 7);
              console.log('Diferencia dias mes 1 semana 1-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 4;
           }  else if( this.diferenciaDiasM > 14 && this.diferenciaDiasM <= 20){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 14);
              console.log('Diferencia dias mes 1 semana 2-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 4;
           } else if( this.diferenciaDiasM > 21 && this.diferenciaDiasM <= 27){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 21);
              console.log('Diferencia dias mes 1 semana 3-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 4;
           }  else if( this.diferenciaDiasM > 28 && this.diferenciaDiasM <= 29){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 28);
              console.log('Diferencia dias mes 1 semana 4-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 4;
           } else if( this.diferenciaDiasM == 0){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = false;
              this.semanasMes = 0;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 4;
           } else if( this.diferenciaDiasM == 7){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 4;
           } else if( this.diferenciaDiasM == 14 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 4;
           } else if( this.diferenciaDiasM == 21 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 4;
           } else if( this.diferenciaDiasM == 28 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 4;
           } else {
             this.semanasMes = 0;
              this.semanasExtrasMes = false;
              this.diasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 4;
           }
         } else
         
         if( resta >= 150 && resta <= 179){
      	   console.log('días -->',resta);
           this.diferenciaDiasM = (resta - 150);
           if( this.diferenciaDiasM > 0 && this.diferenciaDiasM < 7){
             this.diferenciaDiasMes = this.diferenciaDiasM;
             console.log('Días extras-->',this.diferenciaDiasMes);
             this.semanasMes = 0;
              this.diasExtrasMes = true;
              this.semanasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 5;
           } else if( this.diferenciaDiasM > 7 && this.diferenciaDiasM <= 13){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 7);
              console.log('Diferencia dias mes 1 semana 1-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 5;
           }  else if( this.diferenciaDiasM > 14 && this.diferenciaDiasM <= 20){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 14);
              console.log('Diferencia dias mes 1 semana 2-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 5;
           } else if( this.diferenciaDiasM > 21 && this.diferenciaDiasM <= 27){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 21);
              console.log('Diferencia dias mes 1 semana 3-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 5;
           }  else if( this.diferenciaDiasM > 28 && this.diferenciaDiasM <= 29){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 28);
              console.log('Diferencia dias mes 1 semana 4-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 5;
           } else if( this.diferenciaDiasM == 0){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = false;
              this.semanasMes = 0;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 5;
           } else if( this.diferenciaDiasM == 7){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 5;
           } else if( this.diferenciaDiasM == 14 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 5;
           } else if( this.diferenciaDiasM == 21 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 5;
           } else if( this.diferenciaDiasM == 28 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 5;
           } else {
              this.semanasMes = 0;
              this.semanasExtrasMes = false;
              this.diasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 5;
           }
         } else
         
         if( resta >= 180 && resta <= 209){
      	   console.log('días -->',resta);
           this.diferenciaDiasM = (resta - 180);
           if( this.diferenciaDiasM > 0 && this.diferenciaDiasM < 7){
             this.diferenciaDiasMes = this.diferenciaDiasM;
             console.log('Días extras-->',this.diferenciaDiasMes);
              this.semanasMes = 0;
              this.diasExtrasMes = true;
              this.semanasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 6;
           } else if( this.diferenciaDiasM > 7 && this.diferenciaDiasM <= 13){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 7);
              console.log('Diferencia dias mes 1 semana 1-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 6;
           }  else if( this.diferenciaDiasM > 14 && this.diferenciaDiasM <= 20){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 14);
              console.log('Diferencia dias mes 1 semana 2-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 6;
           } else if( this.diferenciaDiasM > 21 && this.diferenciaDiasM <= 27){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 21);
              console.log('Diferencia dias mes 1 semana 3-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 6;
           }  else if( this.diferenciaDiasM > 28 && this.diferenciaDiasM <= 29){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 28);
              console.log('Diferencia dias mes 1 semana 4-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 6;
           } else if( this.diferenciaDiasM == 0){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = false;
              this.semanasMes = 0;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 6;
           } else if( this.diferenciaDiasM == 7){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 6;
           } else if( this.diferenciaDiasM == 14 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 6;
           } else if( this.diferenciaDiasM == 21 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 6;
           } else if( this.diferenciaDiasM == 28 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 6;
           } else {
             this.semanasMes = 0;
              this.semanasExtrasMes = false;
              this.diasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 6;
           }
         } else
         
         if( resta >= 210 && resta <= 239){
      	   console.log('días -->',resta);
           this.diferenciaDiasM = (resta - 210);
           if( this.diferenciaDiasM > 0 && this.diferenciaDiasM < 7){
             this.diferenciaDiasMes = this.diferenciaDiasM;
             console.log('Días extras-->',this.diferenciaDiasMes);
             this.semanasMes = 0;
              this.diasExtrasMes = true;
              this.semanasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 7;
           } else if( this.diferenciaDiasM > 7 && this.diferenciaDiasM <= 13){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 7);
              console.log('Diferencia dias mes 1 semana 1-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 7;
           }  else if( this.diferenciaDiasM > 14 && this.diferenciaDiasM <= 20){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 14);
              console.log('Diferencia dias mes 1 semana 2-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 7;
           } else if( this.diferenciaDiasM > 21 && this.diferenciaDiasM <= 27){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 21);
              console.log('Diferencia dias mes 1 semana 3-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 7;
           }  else if( this.diferenciaDiasM > 28 && this.diferenciaDiasM <= 29){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 28);
              console.log('Diferencia dias mes 1 semana 4-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 7;
           } else if( this.diferenciaDiasM == 0){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = false;
              this.semanasMes = 0;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 7;
           } else if( this.diferenciaDiasM == 7){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 7;
           } else if( this.diferenciaDiasM == 14 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 7;
           } else if( this.diferenciaDiasM == 21 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 7;
           } else if( this.diferenciaDiasM == 28 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 7;
           } else {
             this.semanasMes = 0;
              this.semanasExtrasMes = false;
              this.diasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 7;
           }
         } else
         
         if( resta >= 240 && resta <= 269){
      	   console.log('días -->',resta);
           this.diferenciaDiasM = (resta - 240);
           if( this.diferenciaDiasM > 0 && this.diferenciaDiasM < 7){
             this.diferenciaDiasMes = this.diferenciaDiasM;
             console.log('Días extras-->',this.diferenciaDiasMes);
             this.semanasMes = 0;
              this.diasExtrasMes = true;
              this.semanasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 8;
           } else if( this.diferenciaDiasM > 7 && this.diferenciaDiasM <= 13){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 7);
              console.log('Diferencia dias mes 1 semana 1-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 8;
           }  else if( this.diferenciaDiasM > 14 && this.diferenciaDiasM <= 20){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 14);
              console.log('Diferencia dias mes 1 semana 2-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 8;
           } else if( this.diferenciaDiasM > 21 && this.diferenciaDiasM <= 27){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 21);
              console.log('Diferencia dias mes 1 semana 3-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 8;
           }  else if( this.diferenciaDiasM > 28 && this.diferenciaDiasM <= 29){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 28);
              console.log('Diferencia dias mes 1 semana 4-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 8;
           } else if( this.diferenciaDiasM == 0){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = false;
              this.semanasMes = 0;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 8;
           } else if( this.diferenciaDiasM == 7){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 8;
           } else if( this.diferenciaDiasM == 14 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 8;
           } else if( this.diferenciaDiasM == 21 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 8;
           } else if( this.diferenciaDiasM == 28 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 8;
           } else {
             this.semanasMes = 0;
              this.semanasExtrasMes = false;
              this.diasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 8;
           }
         } else
         
         if( resta >= 270 && resta <= 299){
      	   console.log('días -->',resta);
           this.diferenciaDiasM = (resta - 270);
           if( this.diferenciaDiasM > 0 && this.diferenciaDiasM < 7){
             this.diferenciaDiasMes = this.diferenciaDiasM;
             console.log('Días extras-->',this.diferenciaDiasMes);
             this.semanasMes = 0;
              this.diasExtrasMes = true;
              this.semanasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 9;
           } else if( this.diferenciaDiasM > 7 && this.diferenciaDiasM <= 13){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 7);
              console.log('Diferencia dias mes 1 semana 1-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 9;
           }  else if( this.diferenciaDiasM > 14 && this.diferenciaDiasM <= 20){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 14);
              console.log('Diferencia dias mes 1 semana 2-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 9;
           } else if( this.diferenciaDiasM > 21 && this.diferenciaDiasM <= 27){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 21);
              console.log('Diferencia dias mes 1 semana 3-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 9;
           }  else if( this.diferenciaDiasM > 28 && this.diferenciaDiasM <= 29){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 28);
              console.log('Diferencia dias mes 1 semana 4-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 9;
           } else if( this.diferenciaDiasM == 0){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = false;
              this.semanasMes = 0;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 9;
           } else if( this.diferenciaDiasM == 7){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 9;
           } else if( this.diferenciaDiasM == 14 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 9;
           } else if( this.diferenciaDiasM == 21 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 9;
           } else if( this.diferenciaDiasM == 28 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 9;
           } else {
             this.semanasMes = 0;
              this.semanasExtrasMes = false;
              this.diasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 9;
           }
         }
         
         if( resta >= 300 && resta <= 329){
      	   console.log('días -->',resta);
           this.diferenciaDiasM = (resta - 300);
           if( this.diferenciaDiasM > 0 && this.diferenciaDiasM < 7){
             this.diferenciaDiasMes = this.diferenciaDiasM;
             console.log('Días extras-->',this.diferenciaDiasMes);
             this.semanasMes = 0;
              this.diasExtrasMes = true;
              this.semanasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 10;
           } else if( this.diferenciaDiasM > 7 && this.diferenciaDiasM <= 13){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 7);
              console.log('Diferencia dias mes 1 semana 1-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 10;
           }  else if( this.diferenciaDiasM > 14 && this.diferenciaDiasM <= 20){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 14);
              console.log('Diferencia dias mes 1 semana 2-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 10;
           } else if( this.diferenciaDiasM > 21 && this.diferenciaDiasM <= 27){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 21);
              console.log('Diferencia dias mes 1 semana 3-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 10;
           }  else if( this.diferenciaDiasM > 28 && this.diferenciaDiasM <= 29){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 28);
              console.log('Diferencia dias mes 1 semana 4-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 10;
           } else if( this.diferenciaDiasM == 0){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = false;
              this.semanasMes = 0;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 10;
           } else if( this.diferenciaDiasM == 7){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 10;
           } else if( this.diferenciaDiasM == 14 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 10;
           } else if( this.diferenciaDiasM == 21 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 10;
           } else if( this.diferenciaDiasM == 28 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 10;
           } else {
             this.semanasMes = 0;
              this.semanasExtrasMes = false;
              this.diasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 10;
           }
         } else
         
         if( resta >= 330 && resta <= 359){
      	   console.log('días -->',resta);
           this.diferenciaDiasM = (resta - 330);
           if( this.diferenciaDiasM > 0 && this.diferenciaDiasM < 7){
             this.diferenciaDiasMes = this.diferenciaDiasM;
             console.log('Días extras-->',this.diferenciaDiasMes);
             this.semanasMes = 0;
              this.diasExtrasMes = true;
              this.semanasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 11;
           } else if( this.diferenciaDiasM > 7 && this.diferenciaDiasM <= 13){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 7);
              console.log('Diferencia dias mes 1 semana 1-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 11;
           }  else if( this.diferenciaDiasM > 14 && this.diferenciaDiasM <= 20){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 14);
              console.log('Diferencia dias mes 1 semana 2-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 11;
           } else if( this.diferenciaDiasM > 21 && this.diferenciaDiasM <= 27){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 21);
              console.log('Diferencia dias mes 1 semana 3-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 11;
           }  else if( this.diferenciaDiasM > 28 && this.diferenciaDiasM <= 29){
              this.diferenciaDiasMes = (this.diferenciaDiasM - 28);
              console.log('Diferencia dias mes 1 semana 4-->', this.diferenciaDiasMes);
              this.diasExtrasMes = true;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 11;
           } else if( this.diferenciaDiasM == 0){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = false;
              this.semanasMes = 0;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 11;
           } else if( this.diferenciaDiasM == 7){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 1;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 11;
           } else if( this.diferenciaDiasM == 14 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 2;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 11;
           } else if( this.diferenciaDiasM == 21 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 3;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 11;
           } else if( this.diferenciaDiasM == 28 ){
              this.diferenciaDiasMes = 0;
              console.log('Semana Exacta -->', this.diferenciaDiasMes);
              this.diasExtrasMes = false;
              this.semanasExtrasMes = true;
              this.semanasMes = 4;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 11;
           } else {
             this.semanasMes = 0;
              this.semanasExtrasMes = false;
              this.diasExtrasMes = false;
              this.mesMenor = false;
              this.mesMayor = false;
              this.mesIgu = false;
              this.fechaM = false;
              this.mesp = true;
              this.mesN = 11;
           }
         } else
         
          if( resta <= 29 && resta >= 1){
            console.log('quince');
            this.semanasMes = 0;
              this.semanasExtrasMes = false;
              this.diasExtrasMes = false;
             this.mesMenor = true;
             this.mesMayor = false;
             this.mesIgu = false;
             this.fechaM = false;
             this.mesp = false;
             this.mesN = 0;
          } else
         
         if( resta > 360 ){
           console.log('diesies');
           this.semanasMes = 0;
            this.semanasExtrasMes = false;
            this.diasExtrasMes = false;
            this.mesMenor = false;
            this.mesMayor = true;
            this.mesIgu = false;
            this.fechaM = false;
            this.mesp = false;
            this.mesN = 0;
         } 

        return this.mesp;
      },

      calcularMeses(){
        this.mesesTotales = ((this.mesN * this.months) + (this.semanasMes * this.weeks) + (this.diferenciaDiasMes * this.days)).toFixed(2);
        console.log('Meses Totales --->', this.mesesTotales);
        return this.mesesTotales;
      },

  },

  created() {
    this.cargarInfoVehiculo();
   },

}
</script>

<style scoped>


</style>